'use client';

import React from 'react';
import { Divider, Inline, Text } from '@tranquility-ai/theme-components/primitives';

/**
 * Shared card header for the CSAM Review Mode finding and the Generate Audit
 * Log filter. Title row with optional status and actions, then the same rule
 * inverse DataList rows use (`--data-list-divider`).
 */

/** Inverse `--data-list-divider`: the line between List View rows. */
const listDividerClass =
  'm-0 bg-[color-mix(in_srgb,var(--text-inverse,#ffffff)_10%,transparent)]';
export function CsamSectionHeader({
  title,
  titleAddon,
  actions,
}: {
  title: string;
  titleAddon?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <div>
      <Inline align="center" justify="between" gap="md" className="px-5 py-3">
        <Inline align="center" gap="sm" className="min-w-0">
          <Text as="h2" variant="body" weight="semibold" className="m-0 min-w-0 truncate">
            {title}
          </Text>
          {titleAddon}
        </Inline>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </Inline>
      <Divider className={listDividerClass} />
    </div>
  );
}
